import { CategoryTarget } from './category/category-target';
import { withSidePanel } from './with-side-panel';

export const CategoryTargetPanel = withSidePanel(CategoryTarget);

